import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPost } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';

export interface DispatchSuggestion {
  recommendation: {
    technicianId: string;
    technicianName: string;
    slotId: string;
    startAt: string;
    endAt: string;
  } | null;
  confidence: number;
  reasoning: string;
  alternatives: Array<{
    technicianId: string;
    technicianName: string;
    slotId: string;
    startAt: string;
    score: number;
  }>;
  scoreBreakdown: Record<string, number>;
}

/** Ask ai-operations (via operations) to suggest the best tech+slot for a booking. */
export function useDispatchSuggestion() {
  return useApiMutation<DispatchSuggestion, { id: string }>({
    mutationFn: ({ id }) =>
      apiPost<DispatchSuggestion>(operationsClient, schedulerEndpoints.suggestDispatch(id)),
    showErrorToast: false,
  });
}
